
 var env = 'online';
//var env = 'test';

var host = {
	online: {
		h1: '/api',
	},
	test: {
		// h1: 'http://192.168.9.229:9000', // 秦莎
		// h1: 'http://192.168.9.237:8080',//傅颖
		// h1:'http://192.168.9.245:8080'//陈伟
		// h1: 'http://172.30.41.7:8081',//服务器
		h1:'http://36.133.113.65:8081',//正式地址
		// h1: '/api',
	}
}

// 图形验证码相关接口
export const captcha = {
	image: host[env].h1 + '/captcha/image', // 生成图形验证码的接口
}


export const api = {
	login:host[env].h1 + '/loginUser/login',
	getYzm:host[env].h1 + '/loginUser/getYzm',//获取用户注册验证码
	register:host[env].h1 + '/loginUser/register',//用户注册
	logout:host[env].h1 + '/loginUser/logout',//用户退出登录
	updatePassword:host[env].h1 + '/loginUser/updatePassword',//登录后修改密码
	getPasWordYzm:host[env].h1 + '/loginUser/getPasWordYzm',//修改密码时获取验证码
	getResetYzm:host[env].h1 + '/loginUser/getResetYzm',//重置时获取验证码
	resetPassWord:host[env].h1 + '/loginUser/resetPassWord',//重置密码

	hotWords:host[env].h1 + '/publicservice/es/getHotWords',//关键词
	homeSearch:host[env].h1 + '/publicservice/es/search',//搜索
	getTop:host[env].h1 + '/publicservice/news/headline/getTop',//今日头条
	getTopPage:host[env].h1 + '/publicservice/news/headline/getMore',//今日头条分页
	getTopDetail:host[env].h1 + '/publicservice/news/headline/getDetail',//今日头条详情
	getTopImg:host[env].h1 + '/publicservice/news/headline/getRollPic',//今日头条图片
	getFocusTop:host[env].h1 + '/publicservice/news/focusreview/getTop',//焦点头条
	getFocusPage:host[env].h1 + '/publicservice/news/focusreview/getMore',//焦点头条分页
	getFocusDetail:host[env].h1 + '/publicservice/news/focusreview/getDetail',//焦点头条详情
	getCompanyTop:host[env].h1 + '/publicservice/news/corporatenews/getTop',//企业头条
	getCompanyPage:host[env].h1 + '/publicservice/news/corporatenews/getMore',//企业头条分页
	getCompanyDetail:host[env].h1 + '/publicservice/news/corporatenews/getDetail',//企业头条详情


	importantNoticeTop6:host[env].h1 + '/publicservice/importNotice/getImportNoticeTop6',//重要通知
	getImportNoticePage:host[env].h1 + '/publicservice/importNotice/getPage',//重要通知分页
	getImportNotice:host[env].h1 + '/publicservice/importNotice/getImportNotice',//重要通知详情
	getNewsInfoTop:host[env].h1 + '/publicservice/newsInfo/getNewsInfoTop6',//最新资讯
	getNewsInfoPage:host[env].h1 + '/publicservice/newsInfo/getPage',//最新资讯分页
	getNewsInfo:host[env].h1 + '/publicservice/newsInfo/getNewsInfo',//最新资讯详情

	
	getDemoPrductTop6:host[env].h1 + '/publicservice/demoProduct/getDemoPrductTop6',//示范产品
	getDemoPrductPage:host[env].h1 + '/publicservice/demoProduct/getPage',//示范产品分页
	getDemoPrductDetail:host[env].h1 + '/publicservice/demoProduct/getDemoPrduct',//示范产品详情
	
	getDemoStrationTop6:host[env].h1 + '/publicservice/demostration/getDemoStrationTop6',//示范应用
	getDemoStrationPage:host[env].h1 + '/publicservice/demostration/getPage',//示范应用分页
	getDemoStrationDetail:host[env].h1 + '/publicservice/demostration/getDemoStration',//示范应用详情
	getIndustryTop6:host[env].h1 + '/publicservice/news/industrynew/getTop',//行业新闻
	getIndustryPage:host[env].h1 + '/publicservice/news/industrynew/getMore',//行业新闻分页
	getIndustryDetail:host[env].h1 + '/publicservice/news/industrynew/getDetail',//行业新闻详情
	getPolicyTop6:host[env].h1 + '/publicservice/news/policy/getTop',//政策法规
	getPolicyPage:host[env].h1 + '/publicservice/news/policy/getMore',//政策法规分页
	getPolicyDetail:host[env].h1 + '/publicservice/news/policy/getDetail',//政策法规详情
	getProductCenterTop:host[env].h1 + '/publicservice/news/productCenter/getTop',//产品中心
	getDeviceType:host[env].h1 + '/publicservice/news/productCenter/getDeviceType',//产品中心目录
	getProductCenterList:host[env].h1 + '/publicservice/news/productCenter/getList',//产品中心列表
	getProductCenterDetail:host[env].h1 + '/publicservice/news/productCenter/getDetail',//产品详情

	getTldCenterTop:host[env].h1 + '/publicservice/news/tldCenter/getTop',//企业中心
	getRollPic:host[env].h1 + '/publicservice/news/tldCenter/getRollPic',//企业中心滚动图片
	getCompanytype:host[env].h1 + '/publicservice/news/tldCenter/getCompanytype',//获取公司类型
	getRegion:host[env].h1 + '/publicservice/news/tldCenter/getRegion',//获取区域分布
	getTldByCompanytype:host[env].h1 + '/publicservice/news/tldCenter/getTldByCompanytype',//获取公司类型查询
	getTldCompanytype:host[env].h1 + '/publicservice/news/tldCenter/getTldCompanytype',//按区域类型查询
	getTldCompanyDetail:host[env].h1 + '/publicservice/news/tldCenter/getDetail',//企业详情
	

	getInformationNoticeTop:host[env].h1 + '/publicservice/news/informationnotice/getTop',//信息通知
	getInformationNoticeDetail:host[env].h1 + '/publicservice/news/informationnotice/getDetail',//信息通知详情
	getInformationNoticePage:host[env].h1 + '/publicservice/news/informationnotice/getMore',//信息通知分页
	


	getPageBzzx:host[env].h1 + '/publicservice/pageBzzx/getPageBzzx',//前端保障中心分页查询
	getTypeTop4:host[env].h1 + '/publicservice/pageBzzx/getTypeTop4',//获取所以数据装备类型排行前四
	getTypeAll:host[env].h1 + '/publicservice/pageBzzx/getTypeAll',//获取所以数据装备类型
	getPageAfterSaleDtoOne:host[env].h1 + '/publicservice/pageBzzx/getPageAfterSaleDtoOne',//示范售后详情
	getEvaluateOne:host[env].h1 + '/publicservice/pageBzzx/getEvaluateOne',//售后评价详情

	getRwjz:host[env].h1 + '/publicservice/monitorCenter/getRwjz',//示范课题任务进展
	getJezyl:host[env].h1 + '/publicservice/monitorCenter/getJezyl',//示范课题示范进展-金额占有率
	getSbzyl:host[env].h1 + '/publicservice/monitorCenter/getSbzyl',//示范课题示范进展-设备占有率
	getSftj:host[env].h1 + '/publicservice/monitorCenter/getSftj',//示范设备统计
	getSbjc:host[env].h1 + '/publicservice/monitorCenter/getSbjc',//示范设备列表
	getYyTj:host[env].h1 + '/publicservice/monitorCenter/getYyTj',//应用监测统计
	getYyjc:host[env].h1 + '/publicservice/monitorCenter/getYyjc',//应用监测列表

	getFbzxPage:host[env].h1 + '/publicservice/fbzx/getPage',//发布中心首页
	getZbfbPage:host[env].h1 + '/publicservice/fbzx/getZbfbPage',//装备发布分页
	getZbfbById:host[env].h1 + '/publicservice/fbzx/getZbfbById',//装备发布byid
	getSffbPage:host[env].h1 + '/publicservice/fbzx/getSffbPage',//示范发布分页
	getSffbById:host[env].h1 + '/publicservice/fbzx/getSffbById',//示范发布byid
	getJsfbPage:host[env].h1 + '/publicservice/fbzx/getJsfbPage',//技术发布分页
	getJsfbById:host[env].h1 + '/publicservice/fbzx/getJsfbById',//技术发布byid

	getFirstPics:host[env].h1 + '/publicservice/jczxqx/getFirstPics',//查询图片列表(器械招商)

	getNewPageZcxxTop7:host[env].h1 + '/publicservice/pageZczx/getNewPageZcxxTop7',//最新招采信息
	getPageZcxxBIDTop5:host[env].h1 + '/publicservice/pageZczx/getPageZcxxBIDTop5',//招标/中标信息
	getNewPageZcxx3:host[env].h1 + '/publicservice/pageZczx/getNewPageZcxx3',//最新器械招商信息
	pageZczxPage:host[env].h1 + '/publicservice/pageZczx/getPage',//招采中心分页
	getDictionaryAll:host[env].h1 + '/dictionary/getDictionaryAll',//获取器械招商目录
	getQXZSDeviceType:host[env].h1 + '/publicservice/pageZczx/getDeviceType', //最新器械招商信息获取类别
	getQxzsPage:host[env].h1 + '/publicservice/jczxqx/getQxzsPage',//器械招商分页
	getQxzsDetail:host[env].h1 + '/publicservice/jczxqx/getQxzsDetail',//查看详情(器械招商)
	getZcxxOne:host[env].h1 + '/publicservice/pageZczx/getZcxxOne',//招采信息详情
	getZcxxQxxxOne:host[env].h1 + '/publicservice/pageZczx/getZcxxQxxxOne',//器械信息详情


	getJLZXDetailList:host[env].h1 + '/publicservice/jlzx/getDetailList',//交流中心筛选查询
	getJLZXNum:host[env].h1 + '/publicservice/jlzx/getNum',//交流中心根据区域统计
	getOrgList:host[env].h1 + '/dictionary/getOrgList', //获取示范机构信息
	getDeviceTypeList:host[env].h1 + '/dictionary/getDeviceTypeList', //获取医疗器械分类
	getJLZXDetail:host[env].h1 + '/publicservice/jlzx/getDetail',//交流中心查看详情
	getJLZXArgusList:host[env].h1 + '/publicservice/jlzx/getArgusList',//交流中心评论信息分页查询
	addArticle:host[env].h1 + '/publicservice/jlzx/addArticle',//交流中心发布文章
	getDeviceList:host[env].h1 + '/dictionary/getDeviceList',//交流中心发贴设备类型
	getTypeCodes:host[env].h1 + '/dictionary/getTypeCodes',//示范类型
	richTextFile:host[env].h1 + '/richText/file',  //文件上传
	getProvinces:host[env].h1 + '/option/getProvinces',//省
	getCities:host[env].h1 + '/option/getCities',//市
	getAreas:host[env].h1 + '/option/getAreas',//县


	addADD:host[env].h1 + '/publicservice/jlzx/add',
	

	addMsg:host[env].h1 + '/common/msg/addMsg',//公众留言
	getMsg:host[env].h1 + '/common/msg/getMsg',//门户获取留言




	
}
